import apiFetch from '../apiFetch'

export default function (token, roleId, body) {
  return apiFetch({ endPoint: `role/${roleId}`, method: 'PUT', body: body, token: token })
}
